module.exports = __webpack_public_path__ + "61873ec.webp";